import React from 'react';
import PropTypes from 'prop-types';
import OfficePageListItem from './OfficePageListItem';
import { getListItemShape, filterByCity, PROP_ID } from 'redux/models/offices/model';
import { goToOfficePage, setCookieResellerId } from '../helpers';
import Styles from './OfficePageList.scss';

const OfficePageList = ({ selectedOffice, offices, activeCity }) => {
  const officesByActiveCity = React.useMemo(() => filterByCity(offices, activeCity), [offices, activeCity]);
  const chooseItemHandler = React.useCallback((office) => {
    goToOfficePage(office);
    setCookieResellerId(office);
  }, []);

  return (
    <div className={Styles.list}>
      <strong className={Styles.listCaption}>{activeCity}</strong>
      {officesByActiveCity.map((office) => (
        <OfficePageListItem
          key={office[PROP_ID]}
          item={office}
          isChosen={office[PROP_ID] === selectedOffice}
          chooseItem={chooseItemHandler}
        />
      ))}
    </div>
  );
};

OfficePageList.propTypes = {
  selectedOffice: PropTypes.number,
  offices: PropTypes.arrayOf(getListItemShape()),
  activeCity: PropTypes.string,
};

export default OfficePageList;
